// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var CardSetupErrorType = function (x) {
    return x;
};
var tsBridgeCardSetupErrorTyp = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("CardSetupErrorType")("__brandCardSetupErrorType"));
    }
};
var writeCardSetupErrorType = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showCardSetupErrorType = Data_Show.showString;
var readCardSetupErrorType = Simple_JSON.readString;
var ordCardSetupErrorType = Data_Ord.ordString;
var newtypeCardSetupErrorType = {
    Coercible0: function () {
        return undefined;
    }
};
var makeCardSetupErrorType = CardSetupErrorType;
var eqCardSetupErrorType = Data_Eq.eqString;
export {
    CardSetupErrorType,
    makeCardSetupErrorType,
    unwrap,
    newtypeCardSetupErrorType,
    eqCardSetupErrorType,
    ordCardSetupErrorType,
    showCardSetupErrorType,
    readCardSetupErrorType,
    writeCardSetupErrorType,
    tsBridgeCardSetupErrorTyp
};
//# sourceMappingURL=index.js.map
